// Static variables and constants
app.addFeature(
	"static",
	function(){
		"use strict";

		this.sec = 1000;
		this.min = this.sec * 60;
		this.hour = this.min * 60;
		this.day = this.hour * 24;
		this.week = this.day * 7;
		this.month = this.day * 30;

		/*
			NOTE:
				This has to do with configuration screens
		*/
		this.operatorOptions = [
			{
				value : "indexOf",
				text : "Contains"
			},
			{
				value : "notIndexOf",
				text : "Does Not Contain"
			},
			{
				value : "===",
				text : "Equals"
			},
			{
				value : "!==",
				text : "Does Not Equal"
			},
			{
				value : ">",
				text : "Greater Than"
			},
			{
				value : ">=",
				text : "Greater Than or Equal To"
			},
			{
				value : "<",
				text : "Lesser Than"
			},
			{
				value : "<=",
				text : "Lesser Than or Equal To"
			}
		];

		return this;
	}
);
